import { gql } from "@apollo/client";

export const CREATE_VISIT = gql`
  mutation CreateVisitMutation($input: CreateVisitInput!) {
    createVisit(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_VISIT = gql`
  mutation UpdateVisitMutation($id: Int!, $input: UpdateVisitInput!) {
    updateVisit(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_VISIT = gql`
  mutation RemoveVisitMutation($id: Int!) {
    removeVisit(id: $id) {
      ok
      error
    }
  }
`;

export const VISIT = gql`
  query VisitQuery($id: Int!) {
    visit(id: $id) {
      ok
      error
      result {
        id
        visitDate
        report
        outcome
        followUpDate
        customer {
          id
          name
        }
        salesRep {
          id
          firstname
        }
      }
    }
  }
`;

export const VISITS = gql`
  query VisitsQuery($where: VisitsFiltersInput!) {
    visits(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        visitDate
        report
        outcome
        followUpDate
        customer {
          id
          name
        }
      }
    }
  }
`;
